import { render } from "./ShowPnl.vue?vue&type=template&id=6b1aa60b"
import script from "./ShowPnl.vue?vue&type=script&lang=js"
export * from "./ShowPnl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__